import about from "../../images/about-1.jpg"

export default function About1() {
  return (
    <>
      <section className="lg:max-w-5xl lg:mx-auto px-5 2xl:px-0 py-10 xl:py-20">
        <img src={about} alt="" />
        <p className="gray my-5">
          Now eldest new tastes plenty mother called misery get. Longer excuse
          for county nor except met its things. Narrow enough sex moment desire
          are. Hold who what come that seen read age its. Contained or estimable
          earnestly so perceived. Imprudence he in sufficient cultivated.
          Delighted promotion improving acuteness an newspaper offending he.
          Misery in am secure theirs giving an. Design on longer thrown oppose
          am.
        </p>
        <p className="gray">
          Now eldest new tastes plenty mother called misery get. Longer excuse
          for county nor except met its things. Narrow enough sex moment desire
          are. Hold who what come that seen read age its. Contained or estimable
          earnestly so perceived. Imprudence he in sufficient cultivated.
          Delighted promotion improving acuteness an newspaper offending he.
          Misery in am secure theirs giving an. Design on longer thrown oppose
          am.
        </p>
      </section>
    </>
  )
}
